export default __webpack_public_path__ + "static/media/S50.ee5ee360.png";